import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { OfferRowComponent } from "./offer-row/offer-row.component";
import { Offer } from "../../../@core/data/offer";
import { OfferService } from "../../../@core/api/offer.service";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-offer-table",
  templateUrl: "./offer-table.component.html",
  styleUrls: ["./offer-table.component.scss"],
})
export class OfferTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  offers: Offer[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 500,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private offerService: OfferService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getOffers();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getOffers();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getOffers();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getOffers() {
    this.loading = true;
    this.offers = <Offer[]>(
      await this.offerService.getOffers(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.offers.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

  async createOffer() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home", "offer"]);
  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getOffers();
  }
}
